// extracted by mini-css-extract-plugin
export var barContainer = "_2g-0";
export var extraThin = "_2g-3";
export var fillBar = "_2g-6";
export var fillContainer = "_2g-4";
export var overflow = "_2g-8";
export var overflowContainer = "_2g-5";
export var regular = "_2g-7";
export var thick = "_2g-1";
export var thin = "_2g-2";